import {
  activatePartnerUser,
  approveProduct,
  deleteItem,
  editItem,
  fetchCategories,
  fetchMarketplaceCategories,
  fetchPartnersItems,
  fetchPartnerUsers,
  fetchSections,
  getProductById,
  toggleItemAvailability,
} from './asyncThunks';

export const fetchPartnerUsersBuilder = builder => {
  builder.addCase(fetchPartnerUsers.pending, state => {
    state.fetchPartnerUsersPending = true;
  });
  builder.addCase(fetchPartnerUsers.fulfilled, (state, action) => {
    const { data, page, maxReached, total, perPage } = action.payload;

    state.partnerUsers.data = data;
    state.partnerUsers.maxReached = maxReached;
    state.partnerUsers.page = page;
    state.partnerUsers.total = total;
    state.partnerUsers.perPage = perPage;

    state.fetchPartnerUsersPending = false;
  });
  builder.addCase(fetchPartnerUsers.rejected, (state, action) => {
    state.fetchPartnerUsersPending = false;
  });
};

export const activatePartnerUserBuilder = builder => {
  builder.addCase(activatePartnerUser.pending, state => {
    state.activatePartnerUserPending = true;
  });
  builder.addCase(activatePartnerUser.fulfilled, (state, { payload }) => {
    const { id } = payload;

    console.log(payload);

    state.partnerUsers.data = state.partnerUsers.data.map(user => {
      if (user.id === id) {
        user.active = true;
      }
      return user;
    });

    state.activatePartnerUserPending = false;
  });
  builder.addCase(activatePartnerUser.rejected, state => {
    state.activatePartnerUserPending = false;
  });
};

export const fetchPartnersItemsBuilder = builder => {
  builder.addCase(fetchPartnersItems.pending, state => {
    state.fetchPartnersItemsPending = true;
  });
  builder.addCase(fetchPartnersItems.fulfilled, (state, action) => {
    const { data, page, maxReached, total, perPage } = action.payload;

    state.partnersItems.data = data;
    state.partnersItems.maxReached = maxReached;
    state.partnersItems.page = page;
    state.partnersItems.total = total;
    state.partnersItems.perPage = perPage;

    state.fetchPartnersItemsPending = false;
  });
  builder.addCase(fetchPartnersItems.rejected, (state, action) => {
    state.fetchPartnersItemsPending = false;
  });
};

export const fetchCategoriesBuilder = builder => {
  builder.addCase(fetchCategories.pending, state => {
    state.fetchCategoriesPending = true;
  });
  builder.addCase(fetchCategories.fulfilled, (state, action) => {
    const { data } = action.payload;

    state.categories = data;
    state.fetchCategoriesPending = false;
  });
  builder.addCase(fetchCategories.rejected, (state, action) => {
    state.fetchCategoriesPending = false;
  });
};

export const fetchMarketplaceCategoriesBuilder = builder => {
  builder.addCase(fetchMarketplaceCategories.pending, state => {
    state.fetchMarketplaceCategoriesPending = true;
  });
  builder.addCase(fetchMarketplaceCategories.fulfilled, (state, action) => {
    const { data } = action.payload;

    state.marketplaceCategories = data;
    state.fetchMarketplaceCategoriesPending = false;
  });
  builder.addCase(fetchMarketplaceCategories.rejected, (state, action) => {
    state.fetchMarketplaceCategoriesPending = false;
  });
};

export const fetchSectionsBuilder = builder => {
  builder.addCase(fetchSections.pending, state => {
    state.fetchSectionsPending = true;
  });
  builder.addCase(fetchSections.fulfilled, (state, action) => {
    const { data } = action.payload;

    state.sections = data;
    state.fetchSectionsPending = false;
  });
  builder.addCase(fetchSections.rejected, (state, action) => {
    state.fetchSectionsPending = false;
  });
};

export const approveProductBuilder = builder => {
  builder.addCase(approveProduct.pending, state => {
    state.approveProductPending = true;
  });
  builder.addCase(approveProduct.fulfilled, (state, action) => {
    const { data } = action.payload;

    state.approveProductPending = false;
  });
  builder.addCase(approveProduct.rejected, (state, action) => {
    state.approveProductPending = false;
  });
};

export const getProductByIdBuilder = builder => {
  builder.addCase(getProductById.pending, state => {
    state.getProductByIdPending = true;
  });
  builder.addCase(getProductById.fulfilled, (state, action) => {
    const { data } = action.payload;
    state.getProductByIdPending = false;

    state.selectedProduct = data;
  });
  builder.addCase(getProductById.rejected, (state, action) => {
    state.getProductByIdPending = false;
  });
};

export const editItemBuilder = builder => {
  builder.addCase(editItem.pending, state => {
    state.editItemPending = true;
  });
  builder.addCase(editItem.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.partnersItems.data = state.partnersItems.data.map(item => {
      if (item.id === data.id) {
        item = data;
      }
      return item;
    });

    if (state.selectedProduct.id === data.id) {
      state.selectedProduct = data;
    }

    state.editItemPending = false;
  });
  builder.addCase(editItem.rejected, state => {
    state.editItemPending = false;
  });
};

export const toggleItemAvailabilityBuilder = builder => {
  builder.addCase(toggleItemAvailability.pending, state => {
    state.toggleItemAvailabilityPending = true;
  });
  builder.addCase(toggleItemAvailability.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.partnersItems.data = state.partnersItems.data.map(item => {
      if (item.id === data.id) {
        item.available = !item.available;
      }
      return item;
    });

    if (state.selectedProduct.id === data.id) {
      state.selectedProduct.available = !state.selectedProduct.available;
    }

    state.toggleItemAvailabilityPending = false;
  });
  builder.addCase(toggleItemAvailability.rejected, state => {
    state.toggleItemAvailabilityPending = false;
  });
};

export const deleteItemBuilder = builder => {
  builder.addCase(deleteItem.pending, state => {
    state.deleteItemPending = true;
  });
  builder.addCase(deleteItem.fulfilled, (state, { payload }) => {
    const { id } = payload;
    state.partnersItems.data = state.partnersItems.data.filter(item => item.id !== id);

    state.deleteItemPending = false;
  });
  builder.addCase(deleteItem.rejected, state => {
    state.deleteItemPending = false;
  });
};
